import axios from "axios";
import { backUrl } from "../utils/backURL";
const API_URL = backUrl;

/**
 * Realiza una carga masiva de datos en una tabla específica
 * @param {string} clientId - ID del cliente
 * @param {string} tableName - Nombre de la tabla donde se cargarán los datos
 * @param {Array} items - Array de objetos con los datos a cargar
 * @param {Object} options - Opciones adicionales para la carga masiva
 * @param {string} options.user_name - Nombre del usuario que realiza la carga
 * @returns {Promise<Object>} Resultado de la operación
 */
export const bulkCreateTable = async (clientId, tableName, items, options = {}) => {
  try {
    const response = await axios.post(
      `${API_URL}/workflows/p2p/${clientId}/bulk/${tableName}`,
      { items, options }
    );
    return response.data;
  } catch (error) {
    console.error("Error en bulkCreateTable:", error);
    throw error.response?.data || error;
  }
};

/**
 * Realiza una carga masiva específica de centros de costos
 * Esta función usa el endpoint especializado que maneja automáticamente
 * la conversión de nombres de categorías a IDs
 * @param {string} clientId - ID del cliente
 * @param {Array} items - Array de objetos con los centros de costos a cargar
 * @param {Object} options - Opciones adicionales para la carga masiva
 * @param {string} options.user_name - Nombre del usuario que realiza la carga
 * @returns {Promise<Object>} Resultado de la operación
 */
export const bulkCreateCostCenters = async (clientId, items, options = {}) => {
  try {
    // Enviar evento para mostrar indicador de carga
    const event = new CustomEvent('costCentersBulkUploading', { detail: true });
    window.dispatchEvent(event);

    const response = await axios.post(
      `${API_URL}/workflows/p2p/${clientId}/bulk/cost_centers`,
      { items, options }
    );
    
    // Enviar evento para ocultar indicador de carga
    const endEvent = new CustomEvent('costCentersBulkUploading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar indicador de carga en caso de error
    const endEvent = new CustomEvent('costCentersBulkUploading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error en bulkCreateCostCenters:", error);
    throw error.response?.data || error;
  }
};
